import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Resets scroll to the top whenever the route's pathname changes. Browsers
 * don't do this automatically for client-side (SPA) navigation — without
 * this, clicking a link while scrolled down on the previous page left the
 * next page's content starting mid-way down the viewport instead of at the
 * top.
 *
 * Keyed on `pathname` only, not the full location: filter/sort/pagination
 * changes on `/search` only change the query string (same pathname) and
 * should NOT jump to top — pagination already handles its own smooth scroll,
 * and resetting on every filter tweak would be jarring.
 *
 * Skipped for `POP` navigation (browser back/forward) — the browser's native
 * scroll restoration already returns you to where you were on that page,
 * which is the expected behavior for Back, not a jump to the top.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
